var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 3.24397V3.23947L14.6183 4.7481L18 3.48022L9 0.105225L0 3.48022L9 6.85522L12.3683 5.59185L9 4.2036V4.20022L11.25 3.24397Z",
    fill: "#00B887"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.60522V14.7302L8.4375 17.8948V7.76985L0 4.60522ZM4.5 14.7673L2.25 13.9236V12.7232L4.5 13.567V14.7673Z",
    fill: "#00B887"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 5.87085V8.68897L12.375 9.53272V6.7146L9.5625 7.76985V17.8948L18 14.7302V4.60522L14.625 5.87085Z",
    fill: "#00B887"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxIcon);
export default __webpack_public_path__ + "134fd947b7a64fada27259071e61c49c.svg";
export { ForwardRef as ReactComponent };